import { BCMSRecord, BCMSStateManagerCRUD, useBCMSContext, useModel } from "@bcm-dev/bcms-vite";
import { PageContainer, PageContentView } from "components/shared";
import Classes, { User } from "model";
import React from "react";
import EmailAddressWidget from "./components/EmailAddressWidget";
import PhoneNumberWidget from "./components/PhoneNumberWidget";
import PhysicalAddressWidget from "./components/PhysicalAddressWidget";

import "./styles.css";

/**
 * @function ACTContactInfoForeignPage
 * @return {React.Component}
 * @exported true
 * @description The main component for ACTContactInfoForeignPage
 */
export default function ACTContactInfoForeignPage(props) {
  const { user } = useModel();
  const globalController = useBCMSContext();
  BCMSRecord.globalControllerFor(Classes, globalController);
  const data = { ...getDefaultData(user), ...props.data ?? {} };
  const ui = { ...getDefaultUI(), ...props.ui ?? {} };

  const controller = (state, setState) => ({
    data: state.data,
    ui: state.ui,
    onFormChange: prop => value => {
      const crud = BCMSStateManagerCRUD.init(state);
      if (prop === "physicalAddressType") {
        crud.update(["data", "addressType", prop], value).submit(setState);
      }
      if (prop === "phoneNumberType") {
        crud.update(["data", "addressType", prop], value).submit(setState);
      }
    }

  })
  return (
    <PageContainer className="act-contact-info-foreign-page" state={{ data, ui }} controller={controller}>
      <ACTContactInfoForeignPageContent />
    </PageContainer>
  )
}

export const getDefaultData = (user) => ({
  addressType: {
    physicalAddressType: "domestic",
    phoneNumberType: "domestic"
  },
  user: User.init(user ? user : {})
})

export const getDefaultUI = () => ({
  // no ui changes for now
})

export function ACTContactInfoForeignPageContent(props) {
  return (
    <PageContentView>
      <div className="flex-container flex-vertical flex-width">
        <PhysicalAddressWidget />
        <PhoneNumberWidget />
        <EmailAddressWidget />
      </div>
    </PageContentView>
  );
}